var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ChevronDownSvg from './chevron-down.icon.svg';
export const ChevronDownIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: ChevronDownSvg });
};
_react_refresh_temp_1 = ChevronDownIcon;
$RefreshReg$(_react_refresh_temp_1, "ChevronDownIcon");
